export default __webpack_public_path__ + "static/winter26-83c364d2a39de78ea72a4f1ac804332a.webp";